{
  "@context": "https://schema.org",
  "@type": "Game",
  "name": "Defuse",
  "alternateName": [
    "игра разминировать бомбу", "игра где нужно обезвредить бомбу"
  ],
  "description": "Мини-игра, где игрок должен разминировать бомбу за ограниченное время.",
  "url": "https://6cs.fail/ru/defuse"
}
